import axios from 'axios';
import { BASE_URL } from '../Helpers';

export class SitemapGenerator {
  
  static async generateSitemapContent() {
    try {
      console.log('🚀 Generando contenido de sitemap desde el frontend...');
      
      // Obtener propiedades desde la API
      const propertiesResponse = await axios.get(`${BASE_URL}/housing/sitemap`, {
        timeout: 30000,
        headers: {
          'User-Agent': 'Alohar-Sitemap-Generator/1.0'
        }
      });
      const properties = propertiesResponse.data || [];
      
      // Obtener ciudades desde la API
      const citiesResponse = await axios.get(`${BASE_URL}/cities/active`, {
        timeout: 10000
      });
      const cities = citiesResponse.data || [];
      
      const now = new Date().toISOString();
      
      // Generar XML del sitemap
      let sitemap = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" 
        xmlns:image="http://www.google.com/schemas/sitemap-image/1.1">
  <url>
    <loc>https://alohar.me/</loc>
    <lastmod>${now}</lastmod>
    <changefreq>daily</changefreq>
    <priority>1.0</priority>
  </url>
  <url>
    <loc>https://alohar.me/quiero-ser-alohador</loc>
    <lastmod>${now}</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.8</priority>
  </url>`;

      // Agregar ciudades
      cities.forEach(city => {
        const citySlug = city.name?.toLowerCase().replace(/\s+/g, '-');
        if (citySlug) {
          sitemap += `
  <url>
    <loc>https://alohar.me/${citySlug}/search</loc>
    <lastmod>${now}</lastmod>
    <changefreq>daily</changefreq>
    <priority>0.9</priority>
  </url>`;
        }
      });

      // Agregar propiedades
      properties.forEach(property => {
        const citySlug = property.location?.name?.toLowerCase().replace(/\s+/g, '-') || 'property';
        const imageXML = property.images && property.images.length > 0 
          ? `
    <image:image>
      <image:loc>${property.images[0].url || property.images[0].media}</image:loc>
      <image:title>${property.title || 'Alojamiento en Alohar'}</image:title>
      <image:caption>Alojamiento ${property.title} en ${property.location?.name || 'Argentina'}</image:caption>
    </image:image>`
          : '';

        sitemap += `
  <url>
    <loc>https://alohar.me/${citySlug}/property/${property.id}</loc>
    <lastmod>${property.updated_at || now}</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.8</priority>${imageXML}
  </url>`;
      });

      sitemap += '\n</urlset>';
      
      console.log(`✅ Sitemap generado con ${properties.length} propiedades y ${cities.length} ciudades`);
      return sitemap;
      
    } catch (error) {
      console.error('❌ Error generando sitemap:', error);
      
      // Fallback: generar sitemap básico
      const now = new Date().toISOString();
      const basicSitemap = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  <url>
    <loc>https://alohar.me/</loc>
    <lastmod>${now}</lastmod>
    <changefreq>daily</changefreq>
    <priority>1.0</priority>
  </url>
  <url>
    <loc>https://alohar.me/quiero-ser-alohador</loc>
    <lastmod>${now}</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.8</priority>
  </url>
</urlset>`;
      
      console.log('⚠️  Usando sitemap básico como fallback');
      return basicSitemap;
    }
  }
  
  static async submitToSearchEngines() {
    const sitemapUrls = [
      'https://alohar.me/sitemap.xml',
      'https://alohar.me/sitemap-properties.xml',
      'https://alohar.me/sitemap-cities.xml',
      'https://alohar.me/sitemap-index.xml'
    ];
    
    const results = [];
    
    for (const sitemapUrl of sitemapUrls) {
      try {
        // Google
        const googleResponse = await axios.get(
          `https://www.google.com/ping?sitemap=${encodeURIComponent(sitemapUrl)}`,
          { timeout: 10000 }
        );
        
        // Bing
        const bingResponse = await axios.get(
          `https://www.bing.com/ping?sitemap=${encodeURIComponent(sitemapUrl)}`,
          { timeout: 10000 }
        );
        
        console.log(`📡 Sitemap enviado exitosamente: ${sitemapUrl}`);
        results.push({ url: sitemapUrl, status: 'success' });
        
      } catch (error) {
        console.log(`⚠️  Error enviando ${sitemapUrl}:`, error.message);
        results.push({ url: sitemapUrl, status: 'error', error: error.message });
      }
    }
    
    return results;
  }
  
  // Método para generar sitemap específico de propiedades
  static async generatePropertiesSitemap() {
    try {
      const propertiesResponse = await axios.get(`${BASE_URL}/housing/sitemap`);
      const properties = propertiesResponse.data || [];
      
      const now = new Date().toISOString();
      
      let sitemap = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" 
        xmlns:image="http://www.google.com/schemas/sitemap-image/1.1">`;

      properties.forEach(property => {
        const citySlug = property.location?.name?.toLowerCase().replace(/\s+/g, '-') || 'property';
        const imageXML = property.images && property.images.length > 0 
          ? property.images.slice(0, 5).map(img => `
    <image:image>
      <image:loc>${img.url || img.media}</image:loc>
      <image:title>${property.title}</image:title>
      <image:caption>Alojamiento ${property.title}</image:caption>
    </image:image>`).join('')
          : '';

        sitemap += `
  <url>
    <loc>https://alohar.me/${citySlug}/property/${property.id}</loc>
    <lastmod>${property.updated_at || now}</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.8</priority>${imageXML}
  </url>`;
      });

      sitemap += '\n</urlset>';
      return sitemap;
      
    } catch (error) {
      console.error('❌ Error generando sitemap de propiedades:', error);
      throw error;
    }
  }
}